/* globals THREE */

import { Config } from 'config';

import { Composition, TextureComposition } from '../view';

import { imagePromise } from 'gear';

import { Matrix } from 'cdl';

import { Canvas } from './canvas';

import { Plugin } from '../view';

function createAboveSceneCamera( width, height ) {
  return new THREE.OrthographicCamera( -width/2, width/2, height/2, -height/2, 0, 30 );
}

function updateAboveSceneCamera( camera, width, height ) {
  camera.left   =  width / - 2;
  camera.right  =  width /   2;
  camera.top    = height /   2;
  camera.bottom = height / - 2;
  camera.updateProjectionMatrix();
}

// [TODO] Plugin.TextureImage({ textureType: 'normal', src: ... })

Plugin.NormalMapImage = Plugin.extend({ typeName: 'NormalMapImage',

  target: 'document',
  drawTo_normal: [ 'normal' ],

  Properties: {
    src: { type: 'string', def: 'texture.jpg' }
  },

  initPlugin(view) {
    imagePromise(this.src) .then( image => {
    this.image = image;
    view.redraw('normal');
    console.log('loaded');
    });
  },

  draw({ context, transform }) {
    const { image } = this;
    if( ! image ) {
      return;
    }
    context.save();
    const { canvas } = context;
    context.rect( 0, 0, canvas.width, canvas.height);
    Matrix.m( transform, Matrix.scale( Config.materialScale || 0.2 ) ).transformContext(context);
    context.fillStyle = context.createPattern(image,'repeat');
    context.fill();
    context.restore();
  }
});

export const MaterialCanvas = Canvas.extend({ typeName: 'MaterialCanvas',

  Properties: {

  },

  createTextures() {
    return [ new TextureComposition({ textureType: 'normal' }),
             new TextureComposition({ textureType: 'color'  }) ];
  },

  createScene() {
    return new Composition({ textureType: '3D', main: true });
  },

  createRenderers() {
    return this.callParent().concat( [ Plugin.NormalMapImage({ src: 'texture-'+ ( Config.material || 1 ) +'.jpg' }),
                                       Plugin.Renderer3D() ]);
  },

  init( config = {} ) {
    window.canvas = this;
    this.callParent(config);
    this.initThreeScene();
  },

  initThreeScene() {

    const threeScene = this.threeScene = new THREE.Scene();

    const { width, height } = this;
    this.camera = createAboveSceneCamera(width,height);

    this.createDrawingSurface();

    const light = this._light = new THREE.HemisphereLight(0xaaaaaa, 0x808080, 0.5);
    threeScene.add(light);
    light.position.set(200, 200, 300);

    const light3 = new THREE.PointLight( 0xaaaaaa, 0.5 );
    light3.position.set( 150, 150, 500 );
    threeScene.add(light3);

    const light2 = new THREE.PointLight( 0xaaaaaa, 0.5 );
    light2.position.set( 0, 850, 850 );
    threeScene.add(light2);

    const clamp = function(v){
      const d = 400;
      return Math.min(Math.max(v,-d),d);
    };
    document.addEventListener( 'mousemove', event => {
      const { width, height } = this;
      const p = this.viewPoint(event);
      light2.position.set( clamp( p.x - width/2, 20 ), 850 , 850 + clamp( ( p.y - height / 2 )) );
      this.redraw('3D');
    }, false );
  },

  createDrawingSurface() {
    // There is an issue with updating the texture of the plane geometry
    // For the prototype, I just recreate the scene but we need to fix this
    // to improve performance
    this.updateDrawingSurface();
  },

  updateDrawingSurface() {

    if( this._documentPlane ){
      this.threeScene.remove(this._documentPlane);
      this._documentGeometry.dispose();
      this._documentMaterial.dispose();
    }

    const material = this._documentMaterial = new THREE.MeshPhongMaterial({

      map:  this.texture('color').threeTexture,
      normalMap: this.texture('normal').threeTexture,

      // color      :  new THREE.Color("rgb(155,196,30)"),
      emissive   :  new THREE.Color("#"+( Config.emissive || "222222" )),
      specular   :  new THREE.Color("#"+( Config.specular || "888888" )),
      shininess  :  Config.shininess || 10
    });

    material.transparent = true;

    const { width, height } = this.texture('color').composedCanvas;
    const planeGeometry = this._documentGeometry = new THREE.PlaneBufferGeometry(width,height);

    const plane = this._documentPlane = new THREE.Mesh( planeGeometry, material );

    console.log(this.height - height);
    console.log( width - this.width );
    plane.position.set( (width - this.width)/2, -(height - this.height)/2, 0 );

    this.threeScene.add( plane );
  },

  on_rendercomplete() {
    this.redraw('3D');
    this.callParent(...arguments);
  },

  updateSize( width, height ) {
    this.callParent(width,height);
    this.updateDrawingSurface();

    updateAboveSceneCamera(this.camera,this.width,this.height);
  },

  draw3D( renderer ) {
    console.log('draw 3D');

    renderer.render( this.threeScene, this.camera );
  }
});



/** WEBPACK FOOTER **
 ** ./src/ui/canvas/material-canvas.js
 **/